import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializePaddle } from './services/paddle'
import './lib/bugsnag' // Initialize Bugsnag

// Initialize Paddle with paddle customer ID from localStorage if available
const paddleCustomerId = localStorage.getItem('paddle_customer_id') || undefined;
initializePaddle(paddleCustomerId);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
